import React from 'react';
import Layout from '../../components/Layout/Layout';
import Footer from '../../components/Footer/Footer';
import styles from './FooterPage.module.css';

const FooterPage = () => {
  return (
    <Layout width="1440px">
      <div className={styles.container}>
        <div className={styles.testContent}>
          <h1>Footer Test Page</h1>
          <p>Scroll down to see the footer</p>
          {/* Contenido de prueba para forzar scroll */}
          {Array.from({ length: 20 }, (_, i) => (
            <div key={i} className={styles.spacer}>
              Content block {i + 1}
            </div>
          ))}
        </div>
        <Footer />
      </div>
    </Layout>
  );
};

export default FooterPage;